import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';
import { BetaChip } from './BetaChip';

export const BetaWrapper = ({ children }: PropsWithChildren) => {
  return (
    <Stack
      direction='row'
      sx={{ gap: 2, alignItems: 'center', justifyContent: 'flex-start' }}
    >
      {children}
      <BetaChip />
    </Stack>
  );
};
